<template>
  <div class="animated fadeInRight ecommerce">
    <el-row>
      <el-col :span="24">
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <h5>调拨物品</h5>
            <div class="ibox-tools">
              <el-button type="primary" size="small" @click="_goBack">返回</el-button>
              <el-button type="primary" size="small" @click="_openAllocationOrderInModel">
                <i class="el-icon-plus"></i>选择物品
              </el-button>
            </div>
          </div>
          <div class="ibox-content">
            <el-table :data="allocationOrderInInfo.productManages" border style="width: 100%">
              <el-table-column prop="coverPhoto" label="商品图片" align="center">
                <template slot-scope="scope">
                  <img style="width: 60px; height: 60px; border-radius: 5px;" :src="scope.row.coverPhoto">
                </template>
              </el-table-column>
              <el-table-column prop="productId" label="编号" align="center"></el-table-column>
              <el-table-column prop="prodName" label="名称" align="center"></el-table-column>
              <el-table-column prop="shName" label="原仓库" align="center"></el-table-column>
              <el-table-column label="目标仓库" align="center">
                <template >
                  <el-select v-model="allocationOrderInInfo.targetShId" style="width:100%">
                    <el-option label="请选择目标仓库" value=""></el-option>
                    <el-option v-for="shopHouse in allocationOrderInInfo.shopHouses" 
                               :key="shopHouse.shId"
                               :label="shopHouse.shName"
                               :value="shopHouse.shId">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="defaultSpecValue.specName" label="规格" align="center"></el-table-column>
              <el-table-column prop="defaultSpecValue.stock" label="库存" align="center"></el-table-column>
              <el-table-column label="数量" align="center">
                <template slot-scope="scope">
                  <el-input v-model.number="scope.row.count" type="number" @keyup="_caculTotalMount"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="单价" align="center">
                <template slot-scope="scope">
                  <el-input v-model.number="scope.row.price" type="number" @keyup="_caculTotalMount"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" @click="_deleteProduct(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <h5>调拨说明</h5>
          </div>
          <div class="ibox-content">
            <el-form :model="allocationOrderInInfo" label-width="100px">
              <el-form-item label="申请说明">
                <el-input type="textarea" v-model="allocationOrderInInfo.remark" 
                          placeholder="必填，请填写申请说明"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="22" :offset="2">
        <div style="margin-bottom:10px; text-align:right">
          <el-button type="primary" @click="_submitApply">提交</el-button>
        </div>
      </el-col>
    </el-row>

    <choose-product-and-spec ref="chooseProductAndSpec"></choose-product-and-spec>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { saveAllocationOrder, queryShopHouse } from '@/api/goods/allocationOrderApi'
import ChooseProductAndSpec from '@/components/goods/chooseProductAndSpec/chooseProductAndSpec'

export default {
  name: 'AllocationOrderIn',
  components: {
    ChooseProductAndSpec
  },
  data() {
    return {
      allocationOrderInInfo: {
        productManages: [],
        resourceSuppliers: [],
        shopHouses: [],
        total: 0,
        records: 1,
        remark: '',
        srcShId: '',
        srcShName: '',
        targetShId: '',
        targetShName: '',
        shopName: '',
        count: '',
        productId: '',
        specId: '',
        targetShopId: '',
        targetShopName: '',
        totalMount: 0.00,
        moreCondition: false,
        shopId: getShopId()
      }
    }
  },
  created() {
    this._listAllocationStorehouse()
    this._initEvent()
  },
  methods: {
    _initEvent() {
      this.$on('allocationOrderIn', 'chooseProductAndSpec', (_product) => {
        this.allocationOrderInInfo.productManages.push(_product)
        this.allocationOrderInInfo.shopId = _product.shopId
        this.allocationOrderInInfo.srcShId = _product.shId
        this.allocationOrderInInfo.srcShName = _product.shName
        this.allocationOrderInInfo.productId = _product.productId
        this.allocationOrderInInfo.specId = _product.defaultSpecValue.specId
        this._selectShopHouses(_product.shId)
      })
    },
    _deleteProduct(_Product) {
      let index = this.allocationOrderInInfo.productManages.indexOf(_Product)
      if (index > -1) {
        this.allocationOrderInInfo.productManages.splice(index, 1)
      }
    },
    _openAllocationOrderInModel() {
      this.$refs.chooseProductAndSpec.open()
    },
    _listAllocationStorehouse(_page = 1, _rows = 100) {
      const param = {
        page: _page,
        row: _rows
      }
      console.log(param)
    },
    _goBack() {
      this.$router.go(-1)
    },
    async _submitApply() {
      if (this.allocationOrderInInfo.productManages.length < 1) {
        this.$message.warning('请选择物品')
        return
      }
      if (!this.allocationOrderInInfo.targetShId) {
        this.$message.warning('请选择目标仓库')
        return
      }
      if (this.allocationOrderInInfo.remark === '') {
        this.$message.warning('申请说明不能为空')
        return
      }

      let _saveFlag = true
      this.allocationOrderInInfo.productManages.forEach(item => {
        if (!item.count || item.count <= 0) {
          this.$message.warning('请填写调拨数量')
          _saveFlag = false
          return
        }
        if (parseInt(item.count) > parseInt(item.defaultSpecValue.stock)) {
          this.$message.warning(`${item.prodName}库存不足`)
          _saveFlag = false
          return
        }
        this.allocationOrderInInfo.count = item.count
      })

      if (!_saveFlag) return

      try {
        const res = await saveAllocationOrder(this.allocationOrderInInfo)
        this.$message.success(res.msg)
        this._goBack()
      } catch (error) {
        this.$message.error(error)
      }
    },
    _caculTotalMount() {
      let j = 0
      this.allocationOrderInInfo.productManages.forEach(item => {
        if (!isNaN(item.count) && !isNaN(item.price)) {
          j += parseFloat(item.count) * parseFloat(item.price).toFixed(2)
        } else {
          this.allocationOrderInInfo.totalMount = "请输入正确的数字"
          throw Error()
        }
      })
      this.allocationOrderInInfo.totalMount = j.toFixed(2)
    },
    async _selectShopHouses(shId) {
      const param = {
        shId: shId,
        shopId: this.allocationOrderInInfo.shopId,
        flag: "1",
        page: 1,
        row: 50
      }
      try {
        const res = await queryShopHouse(param)
        this.allocationOrderInInfo.shopHouses = res.data
      } catch (error) {
        this.$message.error(error)
      }
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}
.ibox-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ibox-tools {
  position: relative;
  top: 10px;
}
</style>